import React from 'react'

import {
  StyleSheet,
  View,
} from 'react-native';
import PushNotifications from '../components/communication/PushNotifications';
import PromoCodeEditor from '../components/payments/PromoCodeEditor';

interface Props {
}

const PushNotificationsScreen: React.FC<Props> = ({ 
}) => {   
  return ( 
    <View style={styles.container}>
      <PushNotifications />
    </View>
  )
};

const styles = StyleSheet.create({
  container: {
    alignSelf: 'center',
    flex: 1,
    width: "100%"
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    textAlign: 'center',
    padding: 20
  }
});

export default PushNotificationsScreen